import { createStore } from 'vuex'

export default createStore({
  state: {
    benefitQuestions: [
      {
        id: "rHCk1",
        icon: "same-seat.svg",
        text: "Having the same seat for every game I attend"
      },
      {
        id: "FMUz2",
        icon: "savings.svg",
        text: "The best savings compared to single game prices"
      },
      {
        id: "oNri1",
        icon: "ticket-exchange.svg",
        text: "Easily exchanging tickets to other games when my plans change"
      },
      {
        id: "ENUnU",
        icon: "number-of-tickets.svg",
        text: "Selecting a different number of tickets per game"
      },
      {
        id: "VYxMx",
        icon: "different-locations.svg",
        text: "Trying different seat locations in the ballpark for each game I attend"
      },
      {
        id: "joqWK",
        icon: "seat-location.svg",
        text: "The best possible seats closest to the field"
      },
      {
        id: "6SCHD",
        icon: "access-to-multiple-games.svg",
        text: "Access to multiple games but not for the entire season"
      },
      {
        id: "2BG9r",
        icon: "exclusive-benefit.svg",
        text: "Exclusive benefits such as guaranteed Postseason access"
      },
      {
        id: "4u7di",
        icon: "exclusive-benefit-such-as-guarenteed-postseason-access.svg",
        text: "Access to a private space just for my guests and I"
      },
      {
        id: "tbLRm",
        icon: "seat-location.svg",
        text: "Great seating options while being price conscious"
      },
      {
        id: "L3a7s",
        icon: "access-to-promotional-giveaways.svg",
        text: "Access to promotional giveaways"
      },
      {
        id: "5CxRo",
        icon: "access-to-private-space.svg",
        text: "Hanging out with friends"
      },
      {
        id: "9f9Xk",
        icon: "access-to-private-space.svg",
        text: "Spending time with friends and family"
      },
      {
        id: "CHeZs",
        icon: "exclusive-benefit-such-as-guarenteed-postseason-access.svg",
        text: "Access to a private suite just for my guests and I"
      },
      {
        id: "4bpbs",
        icon: "premium-food.svg",
        text: "Access to premium food options"
      },
      {
        id: "17vug",
        icon: "exclusive-benefit-such-as-guarenteed-postseason-access.svg",
        text: "Access to a private space while being price conscious"
      },
      {
        id: "r81cB",
        icon: "multplie-seats.svg",
        text: "Making sure our seats are together"
      },
      {
        id: "5JWwR",
        icon: "access-to-private-space.svg",
        text: "Spaces for 50+"
      },
      {
        id: "Z5fwc",
        icon: "seat-location.svg",
        text: "Great seat options while being price conscious"
      },
      {
        id: "hD1Y9",
        icon: "seat-location.svg",
        text: "While seat location is important, it's not my primary need"
      },
      {
        id: "rY2kU",
        icon: "exclusive-benefit-such-as-guarenteed-postseason-access.svg",
        text: "Access to a premium suite experience"
      },
      {
        id: "yZBOM",
        icon: "access-to-private-space.svg",
        text: "Hanging out with friends & family"
      },
      {
        id: "xXoC4",
        icon: "savings.svg",
        text: "Options that fit within a budget"
      },
    ],
    benefitPlans: [      
      {
        id:"3Csvx",
        icon: "account-executive.svg",
        text:"Dedicated account executive",
      },
      {
        id:"EHtUJ",
        icon: "employee-appreciation.svg",
        text:"Access to guaranteed perks",
      },
      {
        id:"ABL3m",
        icon: "number-of-tickets.svg",
        text:"Access to choose one of four different plans",
      },
      {
        id: "HIeaz",
        icon: "exclusive-benefit.svg",
        text: "VIP service from a dedicated in-suite host"
      },
      {
        id: "EfKlo",
        icon: "washroom.svg",
        text: "Private in-suite lounge and washroom"
      },
      {
        id: "mMBVQ",
        icon: "premium-food.svg",
        text: "Premium food options"
      },
      {
        id: "BwT1y",
        icon: "door.svg",
        text: "Comfort in all seasons with indoor climate-controlled atmosphere"
      },
      {
        id: "IBtxW",
        icon: "door.svg",
        text: "Dedicated entrance"
      },

      {
        id: "U5xNd",
        icon: "access-to-multiple-games.svg",
        text: "Safe, comfortable ballpark experience"
      },
      {
        id: "ppwIU",
        icon: "savings.svg",
        text: "Affordable price options"
      },
      {
        id: "9948f",
        icon: "washroom.svg",
        text: "Private room and washroom for your guests"
      },
      {
        id: "X3RZd",
        icon: "ball-park-food.svg",
        text: "Ballpark food and beverage options"
      },
      {
        id: "xkWRy",
        icon: "10-tickets.svg",
        text: "Starts at 10 tickets"
      },

      {
        id: "fF9Hl",
        icon: "seat-location.svg",
        text: "Access to best seats at the best price"
      },
      {
        id: "a01nB",
        icon: "ticket-exchange.svg",
        text: "Unlimited ticket exchanges"
      },
      {
        id: "yPdnb",
        icon: "post-season-access.svg",
        text: "Guaranteed postseason access"
      },
      {
        id: "kRCoP",
        icon: "same-seat.svg",
        text: "The same seat for every game"
      },
      {
        id: "xz3CH",
        icon: "jays-shop.svg",
        text: "Discount at Jays Shop"
      },
      {
        id: "QJJjT",
        icon: "employee-appreciation.svg",
        text: "Exclusive Season Ticket benefits"
      },

      {
        id: "Vkic5",
        icon: "seat-location.svg",
        text: "Great seats at low prices"
      },
      {
        id: "g425Z",
        icon: "ticket-exchange.svg",
        text: "Unlimited ticket exchanges to customize your Blue Jays experience"
      },
      {
        id: "dow9e",
        icon: "post-season-access.svg",
        text: "Priority postseason access"
      },    
      {
        id: "Ao5Fz",
        icon: "savings.svg",
        text: "Up to 20% savings"
      },
      {
        id: "1HyMw",
        icon: "10-tickets.svg",
        text: "Options from 12 to 80 tickets"
      },
      {
        id: "GTSEu",
        icon: "10-tickets.svg",
        text: "Use up to 8 tickets per game"
      },
      {
        id: "OWd8S",
        icon: "post-season-access.svg",
        text: "2023 Postseason access for 40+ tickets"
      },

      {
        id: "EGh24",
        icon: "savings.svg",
        text: "Up to 25% savings depending on group size"
      },
      {
        id: "7M362",
        icon: "savings.svg",
        text: "No service fees"
      },
      {
        id: "77DT8",
        icon: "10-tickets.svg",
        text: "25% payment plan option (25+ tickets)"
      },
      {
        id: "p9F6C",
        icon: "access-to-multiple-games.svg",
        text: "Access to home opener"
      },
      {
        id: "qNmNo",
        icon: "post-season-access.svg",
        text: "Videoboard greeting (25+ tickets)"
      }
    ],
    interestOptions: [
      {
        id: "4JFtWVT8JW71i2n",
        text: "I plan on attending multiple games - How do I get the best value and access to exclusive benefits?",
        icon: "few-games.svg",
        image: "interest-01.jpg",
        link: "Games Attending",
      },
      {
        id: "rrooKQtiehmk",
        text: "What options are available for corporate or group events?",
        icon: "corporate-group.svg",
        image: "interest-02.jpg",
        link: "Groups Attending",
      },
      {
        id: "PsT0fDh66CgU",
        text: "I attend one or two games with family and friends, what options are available for me?",
        icon: "family-friends.svg",
        image: "interest-03.jpg",
        link: 'Guests Attending',
      },
      {
        id: "BdrMfplbHeY5jURz",
        text: "What are my options to entertain clients or show appreciation for employees?",
        icon: "employee-appreciation.svg",
        image: "interest-04.jpg",
        link: 'My Options',
      },
    ],
    gameOptions: [
      {
        frequency: "About once a month",
        value: "5-6",
        description: "Games a Year",
        image: "games-per-year-5-6-bg.jpg",
        link: "Ideal Benefits",
        benefits: [          
          {
            benefit: 'FMUz2',
            primary: 'Q5ICL',
            secondary: 'mkJEQ',
          },
          {
            benefit: 'oNri1',
            primary: 'Q5ICL',
            secondary: 'mkJEQ',
          },
          {
            benefit: 'ENUnU',
            primary: 'mkJEQ',
            secondary: '',            
          },
          {
            benefit: 'VYxMx',
            primary: 'mkJEQ',
            secondary: '',            
          },
        ],
      },
      {
        frequency: "About twice a month",
        value: "10-12",
        description: "Games a Year",
        image: "games-per-year-10-12-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'joqWK',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },
          {
            benefit: 'FMUz2',
            primary: 'qzOA8',
            secondary: 'Q5ICL',
          },
          {
            benefit: '6SCHD',
            primary: 'Q5ICL',
            secondary: 'mkJEQ',
          },
          {
            benefit: 'rHCk1',
            primary: 'qzOA8',
            secondary: 'Q5ICL',
          },
        ],
      },
      {
        frequency: "More than twice a month",
        value: "15+",
        description: "Games a Year",
        image: "games-per-year-15-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'joqWK',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },
          {
            benefit: 'FMUz2',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },          
          {
            benefit: 'rHCk1',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },
          {
            benefit: '2BG9r',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },          
        ],
      },
    ],
    groupGuestOptions: [
      {
        value: "1-11",
        image: "games-per-year-5-6-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: '4u7di',
            primary: 'MUklN',
            secondary: '',
          },
          {
            benefit: 'tbLRm',
            primary: 'MUklN',
            secondary: '',
          },
          {            
            benefit: 'L3a7s',
            primary: 'Wtv3Q',
            secondary: 'MUklN',
          },
          {
            benefit: '9f9Xk',
            primary: 'Wtv3Q',
            secondary: 'MUklN',
          },          
        ],
      },
      {
        value: "12-23",
        image: "games-per-year-10-12-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: '4u7di',
            primary: 'AICzI',
            secondary: 'MUklN',            
          },
          {
            benefit: '4bpbs',
            primary: 'AICzI',
            secondary: 'MUklN',            
          },
          {
            benefit: '17vug',
            primary: 'MUklN',
            secondary: '5S4Fi',            
          },
          {
            benefit: 'tbLRm',
            primary: 'J0nKj',
            secondary: 'MUklN',            
          },
          {
            benefit: 'r81cB',
            primary: 'J0nKj',
            secondary: 'MUklN',            
          },
        ],
      },
      {
        value: "24+",
        image: "games-per-year-15-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: '4u7di',
            primary: 'AICzI',
            secondary: 'J0nKj',            
          },
          {
            benefit: '4bpbs',
            primary: 'AICzI',
            secondary: 'J0nKj',
          },
          {
            benefit: '5JWwR',
            primary: 'AICzI',
            secondary: 'J0nKj',
          },
          {
            benefit: 'Z5fwc',
            primary: 'J0nKj',
            secondary: '5S4Fi',
          },
          {
            benefit: 'r81cB',
            primary: 'J0nKj',
            secondary: 'AICzI',
          },
          {
            benefit: 'hD1Y9',
            primary: 'J0nKj',
            secondary: 'AICzI',
          },
        ],
      },
    ],
    guestOptions: [
      {
        value: "1-7",
        image: "games-per-year-5-6-bg.jpg",
        link: "Ideal Benefits",
        benefits: [          
          {
            benefit: '4u7di',
            primary: 'Wtv3Q',
            secondary: 'MUklN',           
          },     
          {
            benefit: 'tbLRm',
            primary: 'Wtv3Q',
            secondary: 'MUklN',
          },               
          {
            benefit: 'L3a7s',
            primary: 'Wtv3Q',
            secondary: '',            
          },      
          {
            benefit: '9f9Xk',
            primary: 'Wtv3Q',
            secondary: 'MUklN',
          },                
        ],
      },
      {
        value: "8-11",
        image: "games-per-year-10-12-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'rY2kU',
            primary: 'AICzI',
            secondary: 'MUklN',
          },
          {
            benefit: '4bpbs',
            primary: 'AICzI',
            secondary: 'MUklN',
          },
          {
            benefit: '17vug',
            primary: 'MUklN',
            secondary: '5S4Fi',            
          },
          {
            benefit: 'Z5fwc',
            primary: 'Wtv3Q',
            secondary: 'MUklN',
          },
          {
            benefit: 'L3a7s',
            primary: 'Wtv3Q',
            secondary: 'MUklN',            
          },
          {
            benefit: 'yZBOM',
            primary: 'MUklN',
            secondary: '',
          },
        ],
      },
      {
        value: "12+",
        image: "games-per-year-15-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'rY2kU',
            primary: 'AICzI',
            secondary: 'MUklN',            
          },
          {
            benefit: '4bpbs',
            primary: 'AICzI',
            secondary: 'MUklN',
          },
          {
            benefit: '17vug',
            primary: 'MUklN',
            secondary: '5S4Fi',            
          },
          {
            benefit: 'Z5fwc',
            primary: 'J0nKj',
            secondary: 'MUklN',            
          },
          {
            benefit: 'r81cB',
            primary: 'J0nKj',
            secondary: 'MUklN',
          },
        ],
      },
    ],        
    corporateOptions: [
      {
        frequency: "A few times a year",
        value: "In Groups of 2 or 4",
        description: "In Best Available Seats",
        image: "games-per-year-5-6-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'joqWK',
            primary: 'qzOA8',
            secondary: 'Q5ICL',            
          },    
          {
            benefit: 'FMUz2',
            primary: 'qzOA8',
            secondary: 'Q5ICL',
          },   
          {
            benefit: '6SCHD',
            primary: 'Q5ICL',
            secondary: 'mkJEQ',
          },
          {
            benefit: 'xXoC4',
            primary: 'mkJEQ',
            secondary: '',
          },          
          {
            benefit: 'oNri1',
            primary: 'Q5ICL',
            secondary: 'mkJEQ',
          },          
          {
            benefit: 'VYxMx',
            primary: 'mkJEQ',
            secondary: '',
          },          
        ],
      },
      {
        frequency: "A few times a year",
        value: "In Larger Groups",
        description: "In a Private Space",
        image: "games-per-year-15-bg.jpg",
        link: "Ideal Benefits",
        benefits: [
          {
            benefit: 'rY2kU',
            primary: 'AICzI',
            secondary: '5S4Fi',            
          },  
          {
            benefit: '4bpbs',
            primary: 'AICzI',
            secondary: 'MUklN',
          },  
          {
            benefit: '17vug',
            primary: 'MUklN',
            secondary: '5S4Fi',
          },  
          {
            benefit: 'tbLRm',
            primary: 'MUklN',
            secondary: '5S4Fi',
          },          
        ],
      },
    ],
    recommendations: [      
      {
        id: "MUklN",
        name: 'Rooms',
        description: 'Our Rooms product provides you a unique private experience at the ballpark! Starting at just 10 tickets, your Room provides a comfortable space to spend time with family and friends or celebrate a special occasion!',
        link: 'https://www.mlb.com/bluejays/tickets/rooms/ticket-finder',
        benefits: [
          "U5xNd",
          "ppwIU",
          "9948f",
          "X3RZd",
          "xkWRy",
        ],
        secondaryTitle:'Looking for a more private space?',
        secondaryMessage:'Learn more about our Rooms product that starts at just 10 tickets!',
      },
      {
        id: "AICzI",
        name: 'TD Executive Suites',
        description: 'A TD Executive Suite provides you the ultimate VIP experience for you and your guests! Suites start at just 12 tickets and provide a luxurious private space, premium food options, private service from a dedicated in-suite host and so much more!',
        link: 'https://www.mlb.com/bluejays/tickets/premium/suites/ticket-finder',
        benefits: [
          "HIeaz",
          "EfKlo",
          "mMBVQ",
          "BwT1y",
          "IBtxW",
        ],
        secondaryTitle:'A TD Executive Suite provides you the ultimate VIP experience for you and your guests!',
        secondaryMessage:'Suites start at just 12 tickets and provide a luxurious private space, premium food options, private service from a dedicated in-suite host and so much more!',
      },
      {
        id: "J0nKj",
        name: 'Group Tickets',
        description: 'Our Groups product offers a great way to connect with family, friends, or colleagues! Starting at just 12 tickets and savings of up to 25%, plan your outing today!',
        link: 'https://www.mlb.com/bluejays/tickets/group-tickets/ticket-finder',
        benefits: [
          "EGh24",
          "7M362",
          "77DT8",
          "p9F6C",
          "qNmNo",
        ],
        secondaryTitle:'Looking for a more price-friendly option?',
        secondaryMessage:'Learn more about group products that provide up to a 15% discount!',
      },                  
      {
        id: "mkJEQ",
        name: 'Ticket Pack',  
        description: 'A Ticket Pack provides you access to your game your way! With savings of up to 20% and options from 12 to 80 tickets, the choice is yours! Core benefits include unlimited ticket exchanges and access to any game with up to 8 tickets per game. The more tickets you buy the more benefits you will get.',
        link: 'https://www.mlb.com/bluejays/tickets/packs/ticket-finder',
        benefits: [
          "Ao5Fz",
          "1HyMw",
          "g425Z",
          "GTSEu",
          "OWd8S",
        ],
        secondaryTitle:'Looking for a smaller plan?',
        secondaryMessage:'Learn more about our Ticket Packs that provide up to 20% savings and great flexibility!',
      },                  
      {
        id: "Q5ICL",
        name: 'Quarter Season Ticket Membership',  
        description: 'A Quarter Season Ticket Membership brings many of the perks of a Blue Jays Full Season Ticket Membership with the choice of a plan that works best for you!',
        link: 'https://www.mlb.com/bluejays/tickets/quarter-season-tickets/ticket-finder',
        benefits: [          
          "ABL3m",
          "kRCoP",
          "Vkic5",
          "g425Z",
          "dow9e",
          "xz3CH",
        ],
        secondaryTitle:'Looking for a smaller plan?',
        secondaryMessage:'Learn more about our Quarter Season Ticket Membership that brings many of the perks of a Blue Jays Full Season Ticket Membership with fewer games and your choice of a plan that works for you!',
      },                  
      {
        id: "qzOA8",
        name: 'Season Ticket Membership',  
        description: 'A Season Ticket Membership provides you with the ultimate Blue Jays experience!',
        link: 'https://www.mlb.com/bluejays/tickets/season-tickets/buy/ticket-finder',
        benefits: [          
          "fF9Hl",
          "a01nB",
          "yPdnb",
          "EHtUJ",
          "xz3CH",
          "3Csvx",
        ],
        secondaryTitle:'Want access to more benefits and the best price?',
        secondaryMessage:'Become a member in 2024',
      },                  
      {
        id: "Wtv3Q",
        name: 'Promotions & Events',  
        description: 'The 2023 Blue Jays season is packed with exciting promotional giveaways and theme days! Check out our promotions & events schedule to plan your outings today!',
        link: 'https://www.mlb.com/bluejays/tickets/promotions/schedule/ticket-finder',
        benefits: [          
        ],
        secondaryTitle:'Looking for fewer games?',
        secondaryMessage:'The 2023 Blue Jays season is packed with exciting promotional giveaways and theme days! Consider purchasing single game tickets for your favourite promotional days today!',
      },
      {
        id: "wVOjX",
        name: 'Single Game Tickets',  
        description: '',
        link: 'https://www.mlb.com/bluejays/tickets/single-game-tickets/ticket-finder',
        benefits: [          
        ],
        secondaryTitle:'Looking to sit in the stands?',
        secondaryMessage:'Learn more about our single game ticket offers today!',
      },
      {
        id: "5S4Fi",
        name: 'Group Spaces',  
        description: 'Private space with great amenities to host your group. Ideal for groups of 20 or more fans.',
        link: 'https://www.mlb.com/bluejays/tickets/group-tickets/group-spaces/ticket-finder',
        benefits: [          
        ],
        secondaryTitle:'Looking for a private space?',
        secondaryMessage:'Host your group of 20 or more fans.',
      }
    ],
    benefitRecommendations: [],
    currentStepTwo:'',
  },
  getters: {
  },
  mutations: {
    setStepTwo(state, stepTwo) {
      state.currentStepTwo = stepTwo;
    },
    setActiveBenefits(state, benefits) {
      state.benefitRecommendations = [];
      state.benefitRecommendations = benefits.map(benefitToEnable => {
        const benefit = { ...benefitToEnable, ...state.benefitQuestions.find(element => element.id === benefitToEnable.benefit) };
        benefit.selected = false;
        return benefit;
      });
    },
    async setPlans() {
      const resolveRouted = router.resolve(router.currentRoute.value.path);
      //console.log('resolve', resolveRouted.name)
      router.push({ name: resolveRouted.name });
    }
  },
  actions: {
  },
  modules: {
  }
})
